__turbopack_context__.v({
  "actions": "ZhMTeG_actions",
  "body": "ZhMTeG_body",
  "book": "ZhMTeG_book",
  "copy": "ZhMTeG_copy",
  "edgeFade": "ZhMTeG_edgeFade",
  "photo": "ZhMTeG_photo",
  "photoDesktop": "ZhMTeG_photoDesktop",
  "photoMobile": "ZhMTeG_photoMobile",
  "scrim": "ZhMTeG_scrim",
  "section": "ZhMTeG_section",
  "sideFade": "ZhMTeG_sideFade",
  "title": "ZhMTeG_title",
});
